import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-container-fluid q-pb-2" }
const _hoisted_2 = { class: "serp__filters--marked-container q-justify-content-between q-flex-wrap q-col-12" }

import MarkedFilterItem from './MarkedFilterItem.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'MarkedFiltersContainer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MarkedFilterItem)
    ])
  ]))
}
}

})